import documentTypes from '../assets/json/documentTypes.json';

const UseDocumentType = (code) => {
    return documentTypes.filter((doc) => doc.tipoDocumentoSAP === code)
        ? documentTypes.filter((doc) => doc.tipoDocumentoSAP === code)[0]
        : 'Tipo de documento no encontrado';
};
export default UseDocumentType;
